import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_food_service_wrkrs_have_valid_healthsanitation_certificatesp'

export const dataPointDefinition = {
  retracedId: 'do_food_service_wrkrs_have_valid_healthsanitation_certificatesp',
  name: 'Do food service workers have valid health/sanitation certificates/permits, as legally required?',
  description:
    'Consult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.\r\r\n\r\r\nAnswer Not Applicable if the facility only has an eating area but no onsite canteen or offsite canteen managed by the facility. ',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna-nalr',
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 4,
      slcpOptionName: 'ynna-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-56--2-7x',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17550,
  sectionId: '2.2.9.11',
  impactArea: 'Canteens',
  impactAreaId: 'CANTEENS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
